import logo from 'assets/images/logo.svg';

export const NavLogo = {
  template: `
    <div class="nav-logo">
      <img class="img-fluid" src="https://belgravia-group.s3-ap-southeast-2.amazonaws.com/coaching-zone/cz_horizontal.jpg">
      <span class="sr-only">Voome</span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavLogo.js